module.exports = __webpack_public_path__ + "img/recs_2.4dcaf710.png";